import { find, test } from 'ramda';
import { useLocation } from 'react-router-dom';

interface UserGaurdProps {
  children: React.ReactElement;
  urlRegexPatterns: RegExp[];
}


export default function URLGaurd({ children, urlRegexPatterns }: UserGaurdProps) {
  const location = useLocation();
  const match = !!find(
    (pattern) => test(pattern, location.pathname),
    urlRegexPatterns,
  );

  if (!match) return null


  return children;
}

